import React from "react";
import { NavLink as NavLinkRRD, Link } from "react-router-dom";
import { PropTypes } from "prop-types";
import { Collapse, DropdownMenu, DropdownItem, UncontrolledDropdown, DropdownToggle, Media, NavbarBrand, Navbar, NavItem, NavLink, Nav, Container, Row, Col } from "reactstrap";
import userPic from "assets/img/brand/employee.svg";
import SweetAlert from "react-bootstrap-sweetalert";
import CookiesService from "../../services/CookiesService";

class Sidebar extends React.Component {
	state = {
		collapseOpen: false,
	};
	constructor(props) {
		super(props);
		this.activeRoute.bind(this);
	}
	// verifies if routeName is the one active (in browser input)
	activeRoute(routeName) {
		return this.props.location.pathname.indexOf(routeName) > -1 ? "active" : "";
	}
	// toggles collapse between opened and closed (true/false)
	toggleCollapse = () => {
		this.setState({
			collapseOpen: !this.state.collapseOpen,
		});
	};
	// closes the collapse
	closeCollapse = () => {
		this.setState({
			collapseOpen: false,
		});
	};
	// creates the links that appear in the left menu / Sidebar
	createLinks = (routes) => {
		return routes.map((prop, key) => {
			return (
				<NavItem key={key}>
					<NavLink to={prop.layout + prop.path} tag={NavLinkRRD} onClick={this.closeCollapse} activeClassName="active">
						<i className={prop.icon} />
						{prop.name}
					</NavLink>
				</NavItem>
			);
		});
	};

	handleClickLogout(e) {
		e.preventDefault();
		const alertLogout = () => <SweetAlert custom showCancel confirmBtnText="Ya" cancelBtnText="Tidak" confirmBtnBsStyle="primary" title="Apakah Anda Yakin Keluar?" onConfirm={() => this.handleLogout()} onCancel={() => this.setState({ alert: null })} focusCancelBtn></SweetAlert>;

		this.setState({
			alert: alertLogout(),
		});
	}

	handleLogout() {
		CookiesService.remove("access_token");
		this.props.history.replace("/login");
	}

	render() {
		const { routes, logo } = this.props;
		let navbarBrandProps;
		if (logo && logo.innerLink) {
			navbarBrandProps = {
				to: logo.innerLink,
				tag: Link,
			};
		} else if (logo && logo.outterLink) {
			navbarBrandProps = {
				href: logo.outterLink,
				target: "_blank",
			};
		}
		return (
			<Navbar className="navbar-vertical fixed-left navbar-light bg-white sticky-top" expand="md" id="sidenav-main">
				<Container fluid>
					<button className="navbar-toggler" type="button" onClick={this.toggleCollapse}>
						<span className="navbar-toggler-icon" />
					</button>

					{logo ? (
						<NavbarBrand className="p-0" {...navbarBrandProps}>
							<img alt={logo.imgAlt} className="navbar-brand-img img-fluid" src={logo.imgMini} />
						</NavbarBrand>
					) : null}

					<Nav className="align-items-center d-md-none">
						<UncontrolledDropdown nav>
							<DropdownToggle className="pr-0" nav>
								<Media className="align-items-center">
									<span className="avatar avatar-sm rounded-circle">
										<img alt="..." src={userPic} />
									</span>
									<Media className="ml-2 d-none d-lg-block">
										<span className="mb-0 text-sm font-weight-bold">Admin</span>
									</Media>
								</Media>
							</DropdownToggle>
							<DropdownMenu className="dropdown-menu-arrow" right>
								<DropdownItem className="noti-title" header tag="div">
									<h6 className="text-overflow m-0">Hai, Apa Kabar?</h6>
								</DropdownItem>
								<DropdownItem divider />
								<DropdownItem onClick={(e) => this.handleClickLogout(e)}>
									<i className="ni ni-user-run" />
									<span>Logout</span>
								</DropdownItem>
							</DropdownMenu>
						</UncontrolledDropdown>
						{this.state.alert}
					</Nav>

					<Collapse navbar isOpen={this.state.collapseOpen}>
						<div className="navbar-collapse-header d-md-none">
							<Row>
								{logo ? (
									<Col className="collapse-brand" xs="8">
										{logo.innerLink ? (
											<Link to={logo.innerLink}>
												<img className="img-fluid" alt={logo.imgAlt} src={logo.imgSrc} style={{ widht: "100%", height: "auto" }} />
											</Link>
										) : (
											<a href={logo.outterLink}>
												<img alt={logo.imgAlt} src={logo.imgMini} />
											</a>
										)}
									</Col>
								) : null}
								<Col className="collapse-close" xs="4">
									<button className="navbar-toggler" type="button" onClick={this.toggleCollapse}>
										<span />
										<span />
									</button>
								</Col>
							</Row>
						</div>

						<Nav navbar>{this.createLinks(routes)}</Nav>

						<hr className="my-3" />
					</Collapse>
				</Container>
			</Navbar>
		);
	}
}

Sidebar.defaultProps = {
	routes: [{}],
};

Sidebar.propTypes = {
	// links that will be displayed inside the component
	routes: PropTypes.arrayOf(PropTypes.object),
	logo: PropTypes.shape({
		// innerLink is for links that will direct the user within the app
		// it will be rendered as <Link to="...">...</Link> tag
		innerLink: PropTypes.string,
		// outterLink is for links that will direct the user outside the app
		// it will be rendered as simple <a href="...">...</a> tag
		outterLink: PropTypes.string,
		// the image src of the logo
		imgSrc: PropTypes.string.isRequired,
		imgMini: PropTypes.string.isRequired,
		// the alt for the img
		imgAlt: PropTypes.string.isRequired,
	}),
};

export default Sidebar;
